<app-enum-i18n [input]="situationsList" (output)="setResources($event)"></app-enum-i18n>

<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
